import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Inject,
    ViewChild
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { FormBuilder } from "@angular/forms";
import { AppService } from "../../../services/app.service";
import { MatStepper } from "@angular/material";
import { Order } from "../../../models/order.model";
import { OrderService } from "../../../services/order.service";
@Component({
    selector: 'app-distributor-order-edit-form',
    templateUrl: './distributor-order-edit-form.component.html',
    styleUrls: ['./distributor-order-edit-form.component.scss']
})
export class DistributorOrderEditFormComponent implements OnInit {
    @Output() closeDialogue = new EventEmitter();
translations: any;
showSaveButton : Boolean = true;
constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public viewMode: any,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public appService: AppService,
    public dialogRef: MatDialogRef<DistributorOrderEditFormComponent>,
    public order: Order,
    private orderService: OrderService
) {
    
    this.setPageTranslations();
    this.order = data;
    this.showSaveButton = !(sessionStorage.getItem("ViewMode") == 'true');
}

ngOnInit() {
    this.appService.showLoading();
}
apiFaillure(error): void {
    this.appService.showDialogue("Error", this.translations[error]);
}
close() {
    this.close();
}

canChangeStatusToDelivered(status){
    if(this.order.Status == 152){ 
        if((this.order.D_ShipDate != undefined && this.order.D_ShipDate.toString() != "") && 
           (this.order.D_LicensePlate != undefined && this.order.D_LicensePlate != "") && 
           (this.order.D_T2No != undefined && this.order.D_T2No != "") && 
           (this.order.D_ReceiveDate != undefined && this.order.D_ReceiveDate.toString() != "") && 
           (this.order.D_PlannedDate != undefined && this.order.D_PlannedDate.toString() != "") && 
           (this.order.D_ActualDate != undefined && this.order.D_ActualDate.toString() != "")){
            return true;              
        }else
            return false;
    }else
        return true;
}

save(): void {
    this.appService.showLoading();
    if(this.canChangeStatusToDelivered('abc')){
    this.order.RegistrationDate = this.appService.JSONDate(
    this.order.RegistrationDate
    );
    this.order.D_ShipDate = this.appService.JSONDate(this.order.D_ShipDate);
    this.order.D_ReceiveDate = this.appService.JSONDate(this.order.D_ReceiveDate);
    this.order.D_PlannedDate = this.appService.JSONDate(this.order.D_PlannedDate);
    this.order.D_ActualDate = this.appService.JSONDate(this.order.D_ActualDate);
    this.order.F_PaymentDate = this.appService.JSONDate(this.order.F_PaymentDate);
    this.orderService
    .save(JSON.stringify(this.order))
    .subscribe(
    res => this.saveOrderSuccess(res),
    error => this.apiFaillure(error)
    );
}else{
    this.showOrderDeliveredStatusDialog(!this.canChangeStatusToDelivered('abc'));
}
}

showOrderDeliveredStatusDialog(flag){
    this.appService.showDialogue(this.translations.lblStatusDialogHeader, this.translations.msgStatusDialogContent, false).afterClosed().subscribe(result => {
        this.close();
    });
}

saveOrderSuccess(res): void {
    if (res.Status == 1) {
        this.appService
            .showDialogue(
            this.translations['hdSuccess'],
            this.translations[res.Message]
        )
            .afterClosed()
            .subscribe(result => {
            if (result) {
                this.close();
            }
        });
    } else {
    this.apiFaillure(res.Message);
}
this.appService.hideLoading();
}

setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}
goBack(stepper: MatStepper) {
    stepper.previous();
}
goForward(stepper: MatStepper) {
    stepper.next();
}

getLabel(){
    return this.order.InvoiceNo != undefined && this.order.C_Name != undefined ? " :: " + this.order.InvoiceNo.toString().toUpperCase() + ' >> ' + this.order.C_Name : "";
}

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order-edit-form/distributor-order-edit-form.component.ts